if (window.globalThis === undefined) {
  window.globalThis = window;
}
